import { c as _c } from "react/compiler-runtime";
import { StateNotice } from "@/sanity/sanity.types";
import PortableTextRenderer from "../utils/PortableTextRenderer";
interface StateNoticeSectionProps {
  data: StateNotice;
}
const StateNoticeSection = t0 => {
  const $ = _c(7);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.body) {
    t1 = data.body && <PortableTextRenderer content={data.body} />;
    $[0] = data.body;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.note) {
    t2 = data.note && <div className="mt-6 rounded-md border border-[#e5eaf4] bg-[#f9fafb] p-6"><strong className="mb-2 block font-semibold text-[#1b2a2f]">NOTE:</strong><p className="text-[18px] leading-relaxed text-[#51656d]">{data.note}</p></div>;
    $[2] = data.note;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default StateNoticeSection;